import { createSelector } from 'reselect'

const selectRoot = state => state.root
const selectError = createSelector(selectRoot, root => root.error || {})
const selectInnerError = createSelector(selectError, error => error.error || {})

//Error code -3 represents invalid username/password
export const selectLoginErrorIsInvalid = createSelector(selectInnerError, error => error.code === -3)
